import axios from 'axios';

export default login => axios.post('/pass/recover', { login })
  .catch(({ response: { data } = {} }) => Promise.reject(new Error(treatError(data))));

const treatError = error => !error || !error.message ? error : error.message;
